export const skillDetails = {
  Javscript: [
    "ES6 이후의 최신 문법에 익숙합니다.",
    "Promise를 활용한 동기/비동기 통신 프로그래밍에 익숙합니다.",
    "자바스크립트의 작동 원리 및 내부 구조를 이해하고 있습니다.",
    "html 태그를 컴포넌트로 추상화하여 구현할 수 있습니다.",
  ],
  Typescript: [
    "객체지향 프로그래밍을 구현할 수 있습니다.",
    "타입 활용을 통한 정적 프로그래밍이 가능합니다.",
  ],
  React: [
    "리액트 동작 원리와 라이프 사이클에 대해 이해하고 있습니다.",
    "상황에 따른 적절한 hook을 사용하고, 모든 컴포넌트를 함수형으로 구현하는데 능숙합니다.",
    "Presentational 컴포넌트와 Container 컴포넌트를 이해하고 적절히 분리하여 구현할 수 있습니다.",
    "Redux를 활용한 상태관리를 구현할 수 있습니다.",
  ],
  Nextjs: [
    "프레임워크의 필요성을 이해하고 있습니다.",
    "SSR과 CSR의 차이를 이해하고 SSR을 적용하는 방법을 알고 있습니다.",
  ],
};
